import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="22" height="18" viewBox="0 0 22 18" xmlns="http://www.w3.org/2000/svg" {...props}><g strokeWidth="2" stroke="currentColor" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round"><path d="M9.5 16.5L1.5 9l8-7.5M21 9H3" /></g></svg>);